import { Stack, Button, IconButton, Tooltip } from "@mui/material";
import {
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  Language as LanguageIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "@/context/ThemeContext";
import { useLocaleToggle } from "@/hooks/useLocaleToggle";

type ToolbarVariant = "page" | "appBar";

interface LocaleAndThemeToolbarProps {
  variant?: ToolbarVariant;
}

export function LocaleAndThemeToolbar({
  variant = "page",
}: LocaleAndThemeToolbarProps) {
  const { t } = useTranslation();
  const { mode, toggleTheme } = useThemeMode();
  const { toggleLocale, otherLocaleName, localeCodeUpper } = useLocaleToggle();

  const inherit = variant === "appBar";

  return (
    <Stack direction="row" spacing={0.5}>
      <Tooltip title={otherLocaleName}>
        <Button
          color={inherit ? "inherit" : "primary"}
          size="small"
          startIcon={<LanguageIcon />}
          onClick={toggleLocale}
          sx={{ minWidth: "auto" }}
        >
          {localeCodeUpper}
        </Button>
      </Tooltip>
      <Tooltip title={mode === "light" ? t("theme.dark") : t("theme.light")}>
        <IconButton
          {...(inherit ? { color: "inherit" as const } : {})}
          onClick={toggleTheme}
          size="small"
        >
          {mode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
